export default {
  api: {
    getManagerTeams: 'splashy/v2/organisation/teams',
    getTeamsAndCountries: 'splashy/v2/organisation/config',
    getOrganisations: 'splashy/v2/organisation/list',
    getReportsData: 'splashy/v2/reports',

    selfService: {
      getSyncFilesList: 'splashy/v2/organisation/onboarding/files',
      uploadRosterFile: 'splashy/v2/organisation/onboarding/upload',
    },
  },
};
